export default __webpack_public_path__ + "static/plx-tr-6ddfe5240bd4a51205e08c32d26a2aff.jpg";